export default __webpack_public_path__ + "static/media/contact-us.8af9c3ba.png";